// @flow
export { default } from './reportError';



// WEBPACK FOOTER //
// ../utilities/reportError/index.client.js